// ZIP (ZCTA) to Arizona county crosswalk for the Map Lab county-shading view.
// Each ZCTA is assigned by point-in-polygon of its Census internal point.
// Generated by backend/scripts/generate_zip_county.py
export const ZIP_COUNTY = {
  "85003": "Maricopa County",
  "85004": "Maricopa County",
  "85006": "Maricopa County",
  "85007": "Maricopa County",
  "85008": "Maricopa County",
  "85009": "Maricopa County",
  "85012": "Maricopa County",
  "85013": "Maricopa County",
  "85014": "Maricopa County",
  "85015": "Maricopa County",
  "85016": "Maricopa County",
  "85017": "Maricopa County",
  "85018": "Maricopa County",
  "85019": "Maricopa County",
  "85020": "Maricopa County",
  "85021": "Maricopa County",
  "85022": "Maricopa County",
  "85023": "Maricopa County",
  "85024": "Maricopa County",
  "85026": "Maricopa County",
  "85027": "Maricopa County",
  "85028": "Maricopa County",
  "85029": "Maricopa County",
  "85031": "Maricopa County",
  "85032": "Maricopa County",
  "85033": "Maricopa County",
  "85034": "Maricopa County",
  "85035": "Maricopa County",
  "85037": "Maricopa County",
  "85040": "Maricopa County",
  "85041": "Maricopa County",
  "85042": "Maricopa County",
  "85043": "Maricopa County",
  "85044": "Maricopa County",
  "85045": "Maricopa County",
  "85048": "Maricopa County",
  "85050": "Maricopa County",
  "85051": "Maricopa County",
  "85053": "Maricopa County",
  "85054": "Maricopa County",
  "85083": "Maricopa County",
  "85085": "Maricopa County",
  "85086": "Maricopa County",
  "85087": "Maricopa County",
  "85118": "Pinal County",
  "85119": "Pinal County",
  "85120": "Pinal County",
  "85121": "Pinal County",
  "85122": "Pinal County",
  "85123": "Pinal County",
  "85128": "Pinal County",
  "85131": "Pinal County",
  "85132": "Pinal County",
  "85135": "Gila County",
  "85137": "Pinal County",
  "85138": "Pinal County",
  "85139": "Maricopa County",
  "85140": "Pinal County",
  "85141": "Pinal County",
  "85142": "Pinal County",
  "85143": "Pinal County",
  "85145": "Pinal County",
  "85147": "Pinal County",
  "85172": "Pinal County",
  "85173": "Pinal County",
  "85191": "Pinal County",
  "85192": "Pinal County",
  "85193": "Pinal County",
  "85194": "Pinal County",
  "85201": "Maricopa County",
  "85202": "Maricopa County",
  "85203": "Maricopa County",
  "85204": "Maricopa County",
  "85205": "Maricopa County",
  "85206": "Maricopa County",
  "85207": "Maricopa County",
  "85208": "Maricopa County",
  "85209": "Maricopa County",
  "85210": "Maricopa County",
  "85212": "Maricopa County",
  "85213": "Maricopa County",
  "85215": "Maricopa County",
  "85224": "Maricopa County",
  "85225": "Maricopa County",
  "85226": "Maricopa County",
  "85233": "Maricopa County",
  "85234": "Maricopa County",
  "85236": "Maricopa County",
  "85248": "Maricopa County",
  "85249": "Maricopa County",
  "85250": "Maricopa County",
  "85251": "Maricopa County",
  "85253": "Maricopa County",
  "85254": "Maricopa County",
  "85255": "Maricopa County",
  "85256": "Maricopa County",
  "85257": "Maricopa County",
  "85258": "Maricopa County",
  "85259": "Maricopa County",
  "85260": "Maricopa County",
  "85262": "Maricopa County",
  "85263": "Maricopa County",
  "85264": "Maricopa County",
  "85266": "Maricopa County",
  "85268": "Maricopa County",
  "85281": "Maricopa County",
  "85282": "Maricopa County",
  "85283": "Maricopa County",
  "85284": "Maricopa County",
  "85286": "Maricopa County",
  "85295": "Maricopa County",
  "85296": "Maricopa County",
  "85297": "Maricopa County",
  "85298": "Maricopa County",
  "85301": "Maricopa County",
  "85302": "Maricopa County",
  "85303": "Maricopa County",
  "85304": "Maricopa County",
  "85305": "Maricopa County",
  "85306": "Maricopa County",
  "85307": "Maricopa County",
  "85308": "Maricopa County",
  "85309": "Maricopa County",
  "85310": "Maricopa County",
  "85320": "Maricopa County",
  "85321": "Pima County",
  "85322": "Maricopa County",
  "85323": "Maricopa County",
  "85324": "Yavapai County",
  "85325": "La Paz County",
  "85326": "Maricopa County",
  "85328": "La Paz County",
  "85329": "Maricopa County",
  "85331": "Maricopa County",
  "85332": "Yavapai County",
  "85333": "Maricopa County",
  "85334": "La Paz County",
  "85335": "Maricopa County",
  "85336": "Yuma County",
  "85337": "Maricopa County",
  "85338": "Maricopa County",
  "85339": "Pinal County",
  "85340": "Maricopa County",
  "85341": "Pima County",
  "85342": "Yavapai County",
  "85343": "Maricopa County",
  "85344": "La Paz County",
  "85345": "Maricopa County",
  "85346": "La Paz County",
  "85347": "Yuma County",
  "85348": "La Paz County",
  "85349": "Yuma County",
  "85350": "Yuma County",
  "85351": "Maricopa County",
  "85352": "Yuma County",
  "85353": "Maricopa County",
  "85354": "Maricopa County",
  "85355": "Maricopa County",
  "85356": "Yuma County",
  "85357": "La Paz County",
  "85360": "Mohave County",
  "85361": "Maricopa County",
  "85362": "Yavapai County",
  "85363": "Maricopa County",
  "85364": "Yuma County",
  "85365": "Yuma County",
  "85367": "Yuma County",
  "85371": "La Paz County",
  "85373": "Maricopa County",
  "85374": "Maricopa County",
  "85375": "Maricopa County",
  "85377": "Maricopa County",
  "85378": "Maricopa County",
  "85379": "Maricopa County",
  "85381": "Maricopa County",
  "85382": "Maricopa County",
  "85383": "Maricopa County",
  "85387": "Maricopa County",
  "85388": "Maricopa County",
  "85390": "Maricopa County",
  "85392": "Maricopa County",
  "85395": "Maricopa County",
  "85396": "Maricopa County",
  "85501": "Gila County",
  "85530": "Graham County",
  "85531": "Graham County",
  "85532": "Gila County",
  "85533": "Greenlee County",
  "85534": "Greenlee County",
  "85535": "Graham County",
  "85536": "Graham County",
  "85539": "Gila County",
  "85540": "Greenlee County",
  "85541": "Gila County",
  "85542": "Graham County",
  "85543": "Graham County",
  "85544": "Gila County",
  "85545": "Maricopa County",
  "85546": "Graham County",
  "85550": "Gila County",
  "85551": "Graham County",
  "85552": "Graham County",
  "85553": "Gila County",
  "85554": "Gila County",
  "85601": "Pima County",
  "85602": "Cochise County",
  "85603": "Cochise County",
  "85605": "Cochise County",
  "85606": "Cochise County",
  "85607": "Cochise County",
  "85608": "Cochise County",
  "85609": "Cochise County",
  "85610": "Cochise County",
  "85611": "Santa Cruz County",
  "85613": "Cochise County",
  "85614": "Pima County",
  "85615": "Cochise County",
  "85616": "Cochise County",
  "85617": "Cochise County",
  "85618": "Pinal County",
  "85619": "Pima County",
  "85620": "Cochise County",
  "85621": "Santa Cruz County",
  "85622": "Pima County",
  "85623": "Pinal County",
  "85624": "Santa Cruz County",
  "85625": "Cochise County",
  "85626": "Cochise County",
  "85627": "Cochise County",
  "85629": "Pima County",
  "85630": "Cochise County",
  "85631": "Pinal County",
  "85632": "Cochise County",
  "85633": "Pima County",
  "85634": "Pima County",
  "85635": "Cochise County",
  "85637": "Santa Cruz County",
  "85638": "Cochise County",
  "85639": "Pima County",
  "85640": "Santa Cruz County",
  "85641": "Pima County",
  "85643": "Graham County",
  "85645": "Santa Cruz County",
  "85646": "Santa Cruz County",
  "85648": "Santa Cruz County",
  "85650": "Cochise County",
  "85653": "Pima County",
  "85654": "Pima County",
  "85658": "Pinal County",
  "85701": "Pima County",
  "85704": "Pima County",
  "85705": "Pima County",
  "85706": "Pima County",
  "85707": "Pima County",
  "85708": "Pima County",
  "85709": "Pima County",
  "85710": "Pima County",
  "85711": "Pima County",
  "85712": "Pima County",
  "85713": "Pima County",
  "85714": "Pima County",
  "85715": "Pima County",
  "85716": "Pima County",
  "85718": "Pima County",
  "85719": "Pima County",
  "85721": "Pima County",
  "85723": "Pima County",
  "85724": "Pima County",
  "85726": "Pima County",
  "85730": "Pima County",
  "85734": "Pima County",
  "85735": "Pima County",
  "85736": "Pima County",
  "85737": "Pima County",
  "85739": "Pinal County",
  "85741": "Pima County",
  "85742": "Pima County",
  "85743": "Pima County",
  "85745": "Pima County",
  "85746": "Pima County",
  "85747": "Pima County",
  "85748": "Pima County",
  "85749": "Pima County",
  "85750": "Pima County",
  "85755": "Pima County",
  "85756": "Pima County",
  "85757": "Pima County",
  "85901": "Navajo County",
  "85902": "Navajo County",
  "85911": "Navajo County",
  "85912": "Navajo County",
  "85920": "Apache County",
  "85922": "Greenlee County",
  "85923": "Navajo County",
  "85924": "Apache County",
  "85925": "Apache County",
  "85926": "Navajo County",
  "85927": "Apache County",
  "85928": "Navajo County",
  "85929": "Navajo County",
  "85930": "Apache County",
  "85931": "Coconino County",
  "85932": "Apache County",
  "85933": "Navajo County",
  "85934": "Navajo County",
  "85935": "Navajo County",
  "85936": "Apache County",
  "85937": "Navajo County",
  "85938": "Apache County",
  "85939": "Navajo County",
  "85940": "Apache County",
  "85941": "Gila County",
  "85942": "Navajo County",
  "86001": "Coconino County",
  "86003": "Coconino County",
  "86004": "Coconino County",
  "86005": "Coconino County",
  "86011": "Coconino County",
  "86015": "Coconino County",
  "86016": "Coconino County",
  "86017": "Coconino County",
  "86018": "Coconino County",
  "86020": "Coconino County",
  "86021": "Mohave County",
  "86022": "Coconino County",
  "86023": "Coconino County",
  "86024": "Coconino County",
  "86025": "Navajo County",
  "86028": "Apache County",
  "86029": "Navajo County",
  "86030": "Coconino County",
  "86031": "Navajo County",
  "86032": "Navajo County",
  "86033": "Navajo County",
  "86034": "Navajo County",
  "86035": "Coconino County",
  "86036": "Coconino County",
  "86038": "Coconino County",
  "86039": "Navajo County",
  "86040": "Coconino County",
  "86042": "Navajo County",
  "86043": "Navajo County",
  "86044": "Coconino County",
  "86045": "Coconino County",
  "86046": "Coconino County",
  "86047": "Navajo County",
  "86052": "Coconino County",
  "86053": "Coconino County",
  "86054": "Navajo County",
  "86301": "Yavapai County",
  "86303": "Yavapai County",
  "86305": "Yavapai County",
  "86313": "Yavapai County",
  "86314": "Yavapai County",
  "86315": "Yavapai County",
  "86320": "Coconino County",
  "86321": "Yavapai County",
  "86322": "Yavapai County",
  "86323": "Yavapai County",
  "86324": "Yavapai County",
  "86325": "Yavapai County",
  "86326": "Yavapai County",
  "86327": "Yavapai County",
  "86329": "Yavapai County",
  "86331": "Yavapai County",
  "86332": "Yavapai County",
  "86333": "Yavapai County",
  "86334": "Yavapai County",
  "86335": "Yavapai County",
  "86336": "Yavapai County",
  "86337": "Yavapai County",
  "86338": "Yavapai County",
  "86343": "Yavapai County",
  "86351": "Yavapai County",
  "86401": "Mohave County",
  "86403": "Mohave County",
  "86404": "Mohave County",
  "86406": "Mohave County",
  "86409": "Mohave County",
  "86411": "Mohave County",
  "86413": "Mohave County",
  "86426": "Mohave County",
  "86429": "Mohave County",
  "86431": "Mohave County",
  "86432": "Mohave County",
  "86433": "Mohave County",
  "86434": "Mohave County",
  "86435": "Coconino County",
  "86436": "Mohave County",
  "86437": "Mohave County",
  "86438": "Mohave County",
  "86440": "Mohave County",
  "86441": "Mohave County",
  "86442": "Mohave County",
  "86443": "Mohave County",
  "86444": "Mohave County",
  "86445": "Mohave County",
  "86502": "Apache County",
  "86503": "Apache County",
  "86504": "Apache County",
  "86505": "Apache County",
  "86506": "Apache County",
  "86507": "Apache County",
  "86508": "Apache County",
  "86510": "Navajo County",
  "86511": "Apache County",
  "86512": "Apache County",
  "86514": "Apache County",
  "86515": "Navajo County",
  "86520": "Apache County",
  "86535": "Apache County",
  "86538": "Apache County",
  "86540": "Apache County",
  "86544": "Apache County",
  "86545": "Apache County",
  "86547": "Apache County",
  "86556": "Apache County",
};
